/**
 * ? @description : This is the component for the batch details table.
 */

// Dependencies
import React from "react";
import { Modal, Button, Tabs, Tab } from "react-bootstrap";

// Sub Components for the batch details table
import BatchDetailsTeacher from "./batch_details/BatchDetailsTeacher";
import BatchDetailsStudent from "./batch_details/BatchDetailsStudent";

function Model(props) {
  const id = props.allbatchesdata.batch_id;
  function capitalizeFirstLetter(str) {
    return str.replace(/\b\w/g, (char) => char.toUpperCase());
  }
  

  return (
    props.batchesdetails !== "" && (
      <Modal
        {...props}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            <h5>Overall Batch View</h5>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Tabs
            defaultActiveKey="group"
            id="uncontrolled-tab-example"
            className="mb-3"
          >
            <Tab eventKey="group" title="Batch">
              <div style={{ display: "none", alignItems: "center" }}>
                <p style={{ width: "200px" }}>
                  <strong>Group Id</strong>
                </p>
                <p>{props.batchesdetails.batch_id}</p>
              </div>

              {/* <br /> */}

              <div style={{ display: "flex", alignItems: "center" }}>
                <p style={{ width: "200px" }}>
                  <strong>Batch Name</strong>
                </p>
                <p>{capitalizeFirstLetter(props.batchesdetails.batch_name)}</p>
              </div>

              <br />

              <div style={{ display: "none", alignItems: "center" }}>
                <p style={{ width: "200px" }}>
                  <strong>Batch Description</strong>
                </p>
                <p>{props.batchesdetails.batch_desc}</p>
              </div>

              {/* <br /> */}

              <div style={{ display: "flex", alignItems: "center" }}>
                <p style={{ width: "200px" }}>
                  <strong>Batch Created By</strong>
                </p>
                <p>{props.batchesdetails.created_by}</p>
              </div>
              <br />
              <div style={{ display: "flex", alignItems: "center" }}>
                <p style={{ width: "200px" }}>
                  <strong>Training Date For Batch</strong>
                </p>
                <p>{props.batchesdetails.training_date_for_batch}</p>
              </div>
            </Tab>

            <Tab eventKey="teachers" title="Teachers">
              <BatchDetailsTeacher id={id} />
            </Tab>

            {/* <Tab eventKey="students" title="Students">
              <BatchDetailsStudent id={id} />
            </Tab> */}
          </Tabs>
        </Modal.Body>

        <Modal.Footer>
          <Button type="button" variant="primary" onClick={props.onHide}>
            CLOSE
          </Button>
        </Modal.Footer>
      </Modal>
    )
  );
}

export default Model;
